module.exports = __webpack_public_path__ + "static/img/3.bd2dfa4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/3.png
// module id = es0u
// module chunks = 0